import { SubdomainForm } from '@/components/organisms/SubdomainForm';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import type { Translation } from '@/lib/i18n';
import type { PlatformValidationResult } from '@/lib/platformApi';

type Props = {
	hasKnownPlatforms: boolean;
	platformHost?: string;
	translation: Translation;
	onSubmit: (subdomain: string) => Promise<PlatformValidationResult>;
	onBack: () => void;
};

export function SubdomainPage({ hasKnownPlatforms, platformHost, translation, onSubmit, onBack }: Props) {
	return (
		<Card
			className="relative w-full max-w-[39.25rem] border-0 bg-white/95 p-0 shadow-[0_1.5rem_4rem_rgba(23,48,42,.09)] max-sm:min-h-[calc(100svh-5.3rem)] max-sm:max-w-none max-sm:rounded-none max-sm:bg-white max-sm:shadow-none"
			aria-labelledby="platform-title"
		>
			<CardHeader className="items-center px-[clamp(1.5rem,5vw,3.25rem)] pt-[clamp(2.5rem,6vw,3.7rem)] pb-0 text-center">
				<CardTitle className="m-0 mb-4 text-[clamp(2rem,4vw,2.7rem)] font-[750] leading-[1.35] tracking-[-.045em] text-[#16221f]">
					<h1
						id="platform-title"
						className="m-0"
					>
						{translation.platformTitle}
					</h1>
				</CardTitle>

				<CardDescription className="m-0 text-[1.05rem] leading-relaxed text-[#68758f]">
					{translation.platformDescription}
				</CardDescription>
			</CardHeader>
			<CardContent className="px-[clamp(1.5rem,5vw,3.25rem)] pb-[clamp(2.5rem,6vw,3.7rem)]">
				<SubdomainForm
					platformHost={platformHost}
					translation={translation}
					onSubmit={onSubmit}
				/>

				{hasKnownPlatforms && (
					<Button
						variant="ghost"
						className="mx-auto mt-4 flex text-primary hover:text-primary-hover active:text-primary-active"
						onClick={onBack}
					>
						{translation.back}
					</Button>
				)}
			</CardContent>
		</Card>
	);
}
